import {isLlmToolFallbackActionText} from '@toolify/client/src/modules/chat/functions/getLlmToolUsedLabel'

interface IAiApprovalActionPayload {
  actionText?: string | null
  toolName?: string | null
}

export function getAiApprovalActionLabel(
  payload: IAiApprovalActionPayload,
  getToolTitle: (toolName: string) => string | null,
): string {
  const actionText = payload.actionText?.trim() || ''
  if(!payload.toolName) {
    return actionText
  }
  if(actionText && !isLlmToolFallbackActionText(payload.toolName, actionText)) {
    return actionText
  }
  return getToolTitle(payload.toolName) || actionText || payload.toolName
}
